



import { Component, Vue } from 'vue-property-decorator';
import Breadcrumb from '@/components/contents/breadcrumb/Breadcrumb.vue';

@Component({
  components: {
    Breadcrumb,
  },
})
export default class Notice extends Vue {
  private breadcrumb: BreadcrumbArr = [
    {
      title: 'HOME',
      link: '/',
    },
    {
      title: 'サイトのご利用上の注意',
      link: '',
    },
  ];
}
